import script from "./ProductDetail.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProductDetail.vue?vue&type=script&lang=ts&setup=true"

import "./ProductDetail.vue?vue&type=style&index=0&id=1a524ec5&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a524ec5"]])

export default __exports__